export default __webpack_public_path__ + "static/media/3125.b43711fc.jpg";